/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetEmployeeAttendance200ResponseItemsInner
 */
export interface GetEmployeeAttendance200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeAttendance200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeAttendance200ResponseItemsInner
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof GetEmployeeAttendance200ResponseItemsInner
     */
    clockIn: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetEmployeeAttendance200ResponseItemsInner
     */
    clockOut?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeAttendance200ResponseItemsInner
     */
    status?: GetEmployeeAttendance200ResponseItemsInnerStatusEnum;
}


/**
 * @export
 */
export const GetEmployeeAttendance200ResponseItemsInnerStatusEnum = {
    Voided: 'voided',
    Overridden: 'overridden'
} as const;
export type GetEmployeeAttendance200ResponseItemsInnerStatusEnum = typeof GetEmployeeAttendance200ResponseItemsInnerStatusEnum[keyof typeof GetEmployeeAttendance200ResponseItemsInnerStatusEnum];


/**
 * Check if a given object implements the GetEmployeeAttendance200ResponseItemsInner interface.
 */
export function instanceOfGetEmployeeAttendance200ResponseItemsInner(value: object): value is GetEmployeeAttendance200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('clockIn' in value) || value['clockIn'] === undefined) return false;
    return true;
}

export function GetEmployeeAttendance200ResponseItemsInnerFromJSON(json: any): GetEmployeeAttendance200ResponseItemsInner {
    return GetEmployeeAttendance200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetEmployeeAttendance200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmployeeAttendance200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'clockIn': (new Date(json['clockIn'])),
        'clockOut': json['clockOut'] == null ? undefined : (new Date(json['clockOut'])),
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function GetEmployeeAttendance200ResponseItemsInnerToJSON(json: any): GetEmployeeAttendance200ResponseItemsInner {
    return GetEmployeeAttendance200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetEmployeeAttendance200ResponseItemsInnerToJSONTyped(value?: GetEmployeeAttendance200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'clockIn': ((value['clockIn']).toISOString()),
        'clockOut': value['clockOut'] == null ? undefined : ((value['clockOut']).toISOString()),
        'status': value['status'],
    };
}

